import TableStatus from './TableStatus.tsx';

export default TableStatus;
